import { Trans } from "@lingui/react/macro";

import { Callout } from "@/common/components/callout/callout";

type Props = React.PropsWithChildren<{
  code?: string;
  onPostalCodeChange: () => void;
  name?: string;
  renderLabel?: (params: { code: string; name: string }) => React.ReactNode;
}>;

const PostalCodeInfoBox = ({
  children,
  code,
  name,
  renderLabel,
  onPostalCodeChange,
}: Props) => (
  <Callout>
    {code && name ? (
      <b>
        {renderLabel?.({ code, name }) ?? (
          <Trans>
            Ceny pro {code}, {name}
          </Trans>
        )}
      </b>
    ) : null}
    <small>{children}</small>
    <button
      className="border-can-forest-teal text-can-forest-teal ml-0 w-full shrink rounded-lg border px-4 py-2 text-xs sm:ml-auto sm:max-w-[259px]"
      onClick={onPostalCodeChange}
    >
      <Trans>Upravit PSČ</Trans>
    </button>
  </Callout>
);

export { PostalCodeInfoBox };
